// Bloqueio de manutenção do site inteiro.
// Para ativar: defina MAINTENANCE_MODE = true e faça deploy.
// Admins autenticados continuam acessando normalmente.
// A rota /auth também é liberada para permitir o login de admin.
// Desativa o bloqueio em ambiente de desenvolvimento do Lovable
// (preview/sandbox) e em dev local. Em produção (zappyconecta.com e
// domínio publicado), o bloqueio permanece ativo.
const isDevEnvironment = (() => {
  if (import.meta.env.DEV) return true;
  if (typeof window === "undefined") return false;
  const host = window.location.hostname;
  // Preview do Lovable: *.lovable.app com prefixo "id-preview--" ou "lovableproject.com"
  return (
    host.startsWith("id-preview--") ||
    host.endsWith(".lovableproject.com") ||
    host === "localhost" ||
    host === "127.0.0.1"
  );
})();

// Mantemos a lógica de dev-bypass disponível, mas o modo está desligado globalmente.
void isDevEnvironment;
export const MAINTENANCE_MODE = false;

export const MAINTENANCE_ALLOWED_PATHS = ["/auth", "/reset-password"];
